// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { ApiServiceError } from "../../../services/api/apiError";

export const BOOTSTRAP_TENANT_NAME_TAKEN = "tenant_already_exists";
export const BOOTSTRAP_MEMBERSHIP_INACTIVE = "membership_inactive";

export class BootstrapTenantError extends Error {
  public readonly name = "BootstrapTenantError";

  constructor(
    message: string,
    public readonly code: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

function readErrorCode(responseBody: string): string | undefined {
  if (responseBody.length === 0) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(responseBody);
    if (typeof parsed !== "object" || parsed === null) {
      return undefined;
    }
    const envelopeError = (parsed as { error?: unknown }).error;
    if (typeof envelopeError !== "object" || envelopeError === null) {
      return undefined;
    }
    const code = (envelopeError as { code?: unknown }).code;
    return typeof code === "string" && code.length > 0 ? code : undefined;
  } catch {
    return undefined;
  }
}

export function toBootstrapTenantError(error: unknown): unknown {
  if (!(error instanceof ApiServiceError)) {
    return error;
  }

  const code = readErrorCode(error.responseBody);
  return code === undefined
    ? error
    : new BootstrapTenantError(error.message, code, error.status);
}
